import { h, Component } from 'preact';
import s from 'components/bolt/fog/fog.sss';
import * as THREE from 'three';

export default class Fog extends Component {
	constructor(props) {
		super(props);

		this.animate = this.animate.bind(this);
		this.onResize = this.onResize.bind(this);
	}

	componentDidMount() {
		window.addEventListener('resize', this.onResize);
		this.init();
	}

	componentWillUnmount() {
		window.removeEventListener('resize', this.onResize);
		window.cancelAnimationFrame(this.animationFrame);
	}

	onResize() {
		this.renderer.setSize(window.innerWidth, window.innerHeight);
		this.camera.updateProjectionMatrix();
	}

	init() {
		this.renderer = new THREE.WebGLRenderer({ alpha: true });
		this.renderer.setSize(window.innerWidth, window.innerHeight);

		this.clock = new THREE.Clock();

		this.scene = new THREE.Scene();

		this.camera = new THREE.PerspectiveCamera(75, window.innerWidth / window.innerHeight, 1, 10000);

		this.camera.position.z = 1000;

		this.camera.position.z = 5;
		this.scene.add(this.camera);
		
		const light = new THREE.DirectionalLight(0xffffff, 1);
		light.position.set(-1, 0, 1);
		this.scene.add(light);

		this.wrapper.appendChild(this.renderer.domElement);

		this.addParticles();

		this.animate();
	}

	addParticles() {
		const { scene } = this;
		const textureLoader = new THREE.TextureLoader();
		const smokeParticles = this.smokeParticles = [];

		
		textureLoader.load(this.props.imageRoot + '/clouds.png', texture => {
			const smokeMaterial = new THREE.MeshLambertMaterial({
				color: 0xd4abff,
				map: texture,
				transparent: true
			});
			smokeMaterial.map.minFilter = THREE.LinearFilter;
			const smokeGeometry = new THREE.PlaneBufferGeometry(4, 4);

			const smokeMeshes = [];
			let limit = 120;

			for (let x = 0; x < limit; x += 1) {
				smokeMeshes[limit] = new THREE.Mesh(smokeGeometry, smokeMaterial);
				smokeMeshes[limit].position.set(Math.random() * 50 - 25, Math.random() * 8 - 8, Math.random());
				smokeMeshes[limit].rotation.z = Math.random() * 360;
				smokeParticles.push(smokeMeshes[limit]);
				scene.add(smokeMeshes[limit]);
			}
		});
	}

	evolveSmoke(delta) {
		const { smokeParticles } = this;
	
		let smokeParticlesLength = smokeParticles.length;
	
		while (smokeParticlesLength--) {
			smokeParticles[smokeParticlesLength].rotation.z += delta * 0.3;
		}
	}

	animate() {
		this.animationFrame = window.requestAnimationFrame(this.animate);
		this.evolveSmoke(this.clock.getDelta());

		this.renderer.render(this.scene, this.camera);
	}

	render() {
		return (
			<div id="fog" class={s.wrapper} ref={ref => this.wrapper = ref} />
		);
	}
}
